import React from "react";
import LuvitComponent from "LuvitComponent";
import format from "lib/format";
import Modal from "lib/components/modal";
import config from "lib/config";
import moment from "moment";
import _ from "lodash";
import { Button } from "Components/Base/Inputs/Button";
import { navigateToMsTeams } from "../../../../domains/programs/functions";
import { GET } from "lib/api";
const dateFormat = config.shortDateFormat.toUpperCase();

export default class CourseDetails extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "ActivityCentre");
  }

  async componentWillMount() {
    let coursesInfo = await GET(
      "v1/user/:personalId/courseobjectinfo/:courseObjectId",
      {
        personalId: this.props.personalId,
        courseObjectId: this.props.course.courseId,
      },
    );

    let activities = coursesInfo[0];
    let onlineCourses = coursesInfo[1];
    this.setState({ activities, onlineCourses, ready: true });
  }

  renderActivities() {
    const { activityId } = this.props;

    const fromProgramView = activityId;

    const fromWhereQueryString = fromProgramView
      ? `&prid=${activityId}&m=pr`
      : "&m=ml";

    let activities = this.state.activities.map((activity) => {
      const { activityId } = activity;
      return (
        <div key={activityId}>
          <h3>{activity.activityTitle}</h3>
          {!activity.isPostRegistration && (
            <>
              <div className="flex">
                <div>{this.l("startdate") + ": "}&nbsp;</div>
                <div>{moment(activity.startDate).format(dateFormat)}</div>
              </div>
              <div className="flex margin-t-5">
                <div>{this.l("enddate") + ": "}&nbsp;</div>
                <div>{moment(activity.endDate).format(dateFormat)}</div>
              </div>
            </>
          )}

          <div className="flex margin-t-5">
            <div>{this.l("location") + ": "}&nbsp;</div>
            <div>{activity.location}</div>
          </div>
          {activity.linkToMeeting && (
            <div className="flex margin-t-5">
              <div>{this.l("linktomeeting") + ": "}&nbsp;</div>
              <div>
                <a
                  href={
                    activity.linkToMeeting.startsWith("http://") ||
                    activity.linkToMeeting.startsWith("https://")
                      ? activity.linkToMeeting
                      : `//${activity.linkToMeeting}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {activity.linkToMeeting}
                </a>
              </div>
            </div>
          )}

          <div className="flex margin-t-5">
            <div>{this.l("practicalinformation") + ": "}&nbsp;</div>
            <div>{activity.locationInfo}</div>
          </div>
          <br />
          {!this.props.isManagerOrAdmin && (
            <div>
              {!activity.isPostRegistration && (
                <a
                  href={
                    format.url("/Activities/ActivityApplication.aspx") +
                    "?id=" +
                    activity.activityID +
                    fromWhereQueryString
                  }
                >
                  {this.l("showapplicationform")}{" "}
                </a>
              )}
              <br />
              {activity.connectedToMSTeams && (
                <div className="flex flex-end">
                  <Button
                    color="secondary"
                    onClick={() => navigateToMsTeams(activity.activityID)}
                    label={this.l("toMSTeams")}
                  />
                </div>
              )}
            </div>
          )}
          <div>{this.renderOnlineCourses(activity.activityID)}</div>
          <br />
        </div>
      );
    });

    return activities;
  }

  renderOnlineCourses(activityId) {
    let self = this;

    let courses = _.filter(this.state.onlineCourses, function (c) {
      return c.activityID === activityId;
    });

    return this.renderOnlineCoursesInternal(courses);
  }

  renderGeneralOnlineCourses() {
    let self = this;

    let courses = _.filter(this.state.onlineCourses, function (c) {
      return !c.activityID;
    });

    return this.renderOnlineCoursesInternal(courses);
  }

  renderOnlineCoursesInternal(courses) {
    courses = _.uniqBy(courses, function (c) {
      return c.courseID;
    });

    if (this.props.isManagerOrAdmin) {
      return courses.map((c) => (
        <div key={c.courseID}>{this.l("onlinecourse") + ": " + c.title}</div>
      ));
    } else {
      return courses.map((c) => (
        <div key={c.courseID}>
          {this.l("entercoursesession") + ": "}
          <a
            href={
              format.url("/education/entercourse.aspx") +
              "?from=ml&courseid=" +
              c.courseID
            }
          >
            {c.title}
          </a>
        </div>
      ));
    }
  }

  render() {
    if (!this.state || !this.state.ready) return <div />;

    return (
      <Modal.Movable
        initiallyOpen
        title={this.props.course.title}
        dialogStyles={{ minWidth: "450px" }}
        afterClose={this.props.closeDetails}
      >
        <div>
          <br />
          {this.renderGeneralOnlineCourses()}
          {this.renderActivities()}
          <div className="flex flex-end margin-b-10 margin-r-10">
            <button
              type="button"
              role="button"
              className="button-cancel"
              onClick={this.props.closeDetails}
            >
              {this.l("close")}
            </button>
          </div>
        </div>
      </Modal.Movable>
    );
  }
}
